import React from 'react';

const MarqueeSectionS5 = () => {
    return (
        <section className="marquee-section-s4">
            <div className="marquee_container">
                <div className="marquee">
                    <h2><span>arketing</span>_<span className="color">digital</span>_ <span>creative</span> agencyent _
                        Chemication</h2>
                </div>
                <div className="marquee">
                    <h2><span>arketing</span>_<span className="color">digital</span>_ <span>creative</span> agencyent _
                        Chemication</h2>
                </div>
            </div>
            <div className="marquee_container s2">
                <div className="marquee-s2">
                    <h2>arketing _ E Designer _ Web development _ Chemication</h2>
                </div>
                <div className="marquee-s2">
                    <h2>arketing _ E Designer _ Web development _ Chemication</h2>
                </div>
            </div>
        </section>
    );
};

export default MarqueeSectionS5;